module.exports = __webpack_public_path__ + "img/galleria7.29b8d437.jpg";